import React from "react";
import MonetaryAmount from "./MonetaryAmount";
import PercentageChange from "./PercentageChange";
import styled from "styled-components";

const MissingPriceText = styled.div`
    font-size: 10px;
    text-align: right;
`;

export const isMonetaryKpi = (name) => ['absolutePnl', 'relativePnl'].includes(name);
export const isUnsignedKpi = (name) => ['absoluteHitRate', 'relativeHitRate', 'customScore', 'consistency', 'intensity', 'normalisedReturn'].includes(name);

const PerformanceValue = ({name, value}) => (
    isMonetaryKpi(name) ? <MonetaryAmount amount={value}/> :
        <PercentageChange change={value} isFraction={true} noLeadingPlus={isUnsignedKpi(name)}/>
);

export default PerformanceValue;

export const OpenIdeaPerformanceValue = ({idea, period}) => {
    const value = idea["relativeReturn" + period];
    if (idea.pricingProgress > 0.0) {
        if (value !== null) {
            return <PercentageChange change={value} isFraction={true} noLeadingPlus={false}/>;
        }
        if (period === "Today" && idea["relativeReturnLifetime"] !== null) {
            return <MissingPriceText>Awaiting Open</MissingPriceText>
        }
    }
    return <PercentageChange change={null}/>;
};
